import { body } from "./elements";
import { wait } from "./lib/helpers";
import { useAccordion } from "./patterns/accordion";
import { useApplicationForm } from "./patterns/applicationForm";
import { useIconLink } from "./patterns/iconLink";
import { useInputNumControls } from "./patterns/inputNumControls";
import { useNavbar } from "./patterns/navbar";
import { usePopUp } from "./patterns/popUp";
import { useSlideBanner } from "./patterns/slideBanner";
import { useSupplierSlider } from "./patterns/suppliersSlider";
import { useTabbedSections } from "./patterns/tabbedSections";
import { useWeeklyMenu } from "./patterns/weeklyMenu";
import { useWeeklyMenuReturningCustomers } from "./patterns/weeklyMenuReturningCustomers";

function init() {
  // Navbar
  useNavbar();

  // Slide Banner
  useSlideBanner();

  // Weekly Menu
  useWeeklyMenu();

  // Tabbed Sections
  useTabbedSections();

  //Accordion
  useAccordion();

  // Suppliers Slider
  useSupplierSlider();

  // Application Form Handling
  useApplicationForm();

  // Icon Link Random Tilt
  useIconLink();

  // Input number controls
  useInputNumControls();

  // Weekly Menu Returning Customer
  useWeeklyMenuReturningCustomers();

  // Pop Up
  usePopUp();
}

document.addEventListener("DOMContentLoaded", init);
